import React from 'react'
import PageHeader from '../components/PageHeader'

const DST_CURIE_Project = () => {
    return (
        <div>
            <PageHeader title="DST CURIE Project" />
        </div>
    )
}

export default DST_CURIE_Project